import axios from 'axios'
import { BASE_FIREBASE_FUNCTIONS_URL } from '../config/config'

/**
 * Check authentication status via session cookie
 * This validates the HTTP-only cookie set by authSignin
 * and returns a Firebase custom token for client-side auth
 */
export const checkAuthStatus = async () => {
  try {
    const res = await axios.post(
      `${BASE_FIREBASE_FUNCTIONS_URL}/authStatus`,
      {},
      { withCredentials: true }
    )
    return res.data
  } catch (err: any) {
    console.error('checkAuthStatus error', err)
    return { success: false }
  }
}
